@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */
    --n-toast-animation-duration-ms: 300;
    --n-toast-animation-duration: calc(
      var(--n-toast-animation-duration-ms) * 1ms
    );

    --n-toast-bg-color: var(--n-color-surface-inverse);
    --n-toast-border-radius: var(--n-border-radius-200);
    --n-toast-font-color: var(--n-text-color-inverse);
    --n-toast-font-size: var(--n-font-size-350);
    --n-toast-lh: 1.35714;
    --n-toast-shadow: var(--n-shadow-400);
  }

  /* ToDo: We probably should represent variants here. For now, all toasts look the same. */
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  @keyframes enter {
    0% {
      display: none;
      opacity: 0;
      grid-template-rows: 0fr;
    }
    1% {
      display: grid;
    }
    10% {
      opacity: 0;
    }
    100% {
      opacity: 1;
      grid-template-rows: 1fr;
    }
  }

  @keyframes exit {
    0% {
      opacity: 1;
      grid-template-rows: 1fr;
    }
    10% {
      grid-template-rows: 1fr;
    }
    100% {
      opacity: 0;
      grid-template-rows: 0fr;
    }
  }

  .toast {
    opacity: 1;
    display: grid;
    grid-template-rows: 1fr;
    width: 100%;
    font-size: var(--n-toast-font-size);
    line-height: var(--n-toast-lh);
    border-radius: var(--n-toast-border-radius);
    box-shadow: var(--n-toast-shadow);
    background-color: var(--n-toast-bg-color);
    color: var(--n-toast-font-color);

    @media (--mq-motion-ok) {
      animation-name: enter;
      animation-duration: var(--n-toast-animation-duration);
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
    }
  }

  .isExiting {
    @media (--mq-motion-ok) {
      animation-name: exit;
    }
  }

  .wrap {
    overflow: hidden;
    width: 100%;
  }

  .contents {
    width: 100%;
  }

  .closeButton {
    color: var(--n-toast-font-color);
  }
}
